import { useTranslations } from '@vocab/react';
import type { IconSvgProps } from 'src/components/common/Icons/types';

import translations from '../.vocab';

export const IconSeekPassSupertickSvg = (props: IconSvgProps) => {
  const { t } = useTranslations(translations);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 22"
      focusable="false"
      fill="currentColor"
      width={14}
      height={14}
      {...props}
    >
      <g>
        <title>{t('Verified Icon')}</title>
        <path
          fill="#503dc9"
          strokeWidth="0px"
          d="m19.49,5.13L10.49.13c-.3-.17-.67-.17-.97,0L.51,5.13c-.32.18-.51.51-.51.87v10c0,.36.2.7.51.87l9,5c.15.08.32.13.49.13s.33-.04.49-.13l9-5c.32-.18.51-.51.51-.87V6c0-.36-.2-.7-.51-.87Z"
        />
        <path
          fill="#fff"
          strokeWidth="0px"
          d="m9,14c-.26,0-.51-.1-.71-.29l-2.71-2.71,1.41-1.41,2,2,4-4,1.41,1.41-4.71,4.71c-.2.2-.45.29-.71.29Z"
        />
      </g>
    </svg>
  );
};
